export default __webpack_public_path__ + "static/media/shopping-cart.970ae18c.svg";